import { render, staticRenderFns } from "./subscribeCrossNode.vue?vue&type=template&id=bfda6538&scoped=true&"
import script from "./subscribeCrossNode.vue?vue&type=script&lang=js&"
export * from "./subscribeCrossNode.vue?vue&type=script&lang=js&"
import style0 from "./subscribeCrossNode.vue?vue&type=style&index=0&id=bfda6538&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfda6538",
  null
  
)

export default component.exports